import { Fragment, useMemo } from 'react'
import { AssetReference } from '@opallabs/cassini'
import { Asset } from '@opallabs/kuiper'
import { ContentTextInput } from '../../../../../ContentTextInput'
import { RedditPromotedFooter } from '../../sharedDisplays/RedditPromotedFooter'
import { RedditPromotedHeader } from '../../sharedDisplays/RedditPromotedHeader'
import * as styles from './styles'

interface SingleProps {
  accountImage: AssetReference | null
  accountUsername: string
  assets: AssetReference[]
  cta: string
  destinationUrl: string
  headline: string
  isPresenting?: boolean
  onExpandAsset?: (assetId: number) => void
  onHeadlineChange?: (val: string) => void
  onRemoveAsset?: (assetId: number) => void
  readOnly: boolean
  updateCaption?: () => void
}

export const Single: React.FC<SingleProps> = ({
  accountImage,
  accountUsername,
  assets,
  cta,
  destinationUrl,
  headline,
  isPresenting = false,
  onExpandAsset,
  onHeadlineChange,
  onRemoveAsset,
  readOnly,
  updateCaption,
}) => {
  const hasCtaBar = Boolean(destinationUrl) || cta !== 'No Button'

  const assetStyles = useMemo(
    () => styles.getAssetStyles(hasCtaBar),
    [hasCtaBar]
  )

  return (
    <Fragment>
      <RedditPromotedHeader
        accountImage={accountImage}
        accountUsername={accountUsername}
      />

      <div css={styles.headlineWrapper}>
        <ContentTextInput
          characterLimit={300}
          placeholder="Add headline..."
          readOnly={readOnly}
          value={headline}
          highlightSocialTags={false}
          onChange={(val) => onHeadlineChange?.(val)}
          style={styles.headlineStyle}
        />
      </div>

      {assets.length > 0 ? (
        <div css={styles.assetWrapper} data-has-cta={hasCtaBar}>
          <Asset
            assetReference={assets[0]}
            hasAssetOptions={true}
            hasAssetOverlay={assets[0] && (!readOnly || isPresenting)}
            imageFit="cover"
            onEmbiggen={() => {
              if (assets[0]?.id) onExpandAsset?.(assets[0].id)
            }}
            onRemove={() => {
              if (assets[0]?.id) onRemoveAsset?.(assets[0].id)
            }}
            overrideStyles={assetStyles}
            placeholder={true}
            removeable={!isPresenting}
            updateCaption={updateCaption}
          />
        </div>
      ) : (
        <div css={styles.emptyAssetPlaceholder}>Add an image or video</div>
      )}

      <RedditPromotedFooter cta={cta} destinationUrl={destinationUrl} />
    </Fragment>
  )
}
